@if ((((data?.deploymentClass === DeploymentClass.D || data?.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.RVT_TEST_NONPII])
  || ((data?.deploymentClass === DeploymentClass.B || data?.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.RVT_TEST_PII])) || !data) {
    <div class="rvt-package">
      <ng-container *ngIf="data?.deploymentClass === DeploymentClass.A">
        <div class="flex items-center justify-center not-applicable">
          {{'INSTANCE_DETAILS.NOT_APPLICABLE_FOR_CLASS_A' | transloco }}
        </div>
      </ng-container>
      <ng-container *ngIf="data?.deploymentClass !== DeploymentClass.A">
        <div class="flex justify-start mb-12">
          <button class="mr-16 fs-16 fw-500 h-40" [ngClass]="selectedRvtTab === 0 ? 'selected-tab fs-18 fw-600' : 'unselected-tab'" (click)="rvtTabChange(0)">{{ 'INSTANCE_DETAILS.RVT_PACKAGE' | transloco }}</button>
          <button class="mr-16 fs-16 fw-500 h-40" [ngClass]="selectedRvtTab === 1 ? 'selected-tab fs-18 fw-600' : 'unselected-tab'" (click)="rvtTabChange(1)">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</button>
        </div>
            <mat-divider class="neutral-2"></mat-divider>
             @if (selectedRvtTab === 0) {
              <app-instance-execute-rvt [executeRvtInProgressing]="executeRvtInProgress" [availableConfigurationsForRvt]="configurationsForRvt"
                (executeRvtClick)="executeRvtClick($event)"  (refreshClick)="loadReleaseData()" [instance]="instance" [configs]="configurations" [configLoaded]="configurationLoaded"></app-instance-execute-rvt>
             }
            @else if (selectedRvtTab === 1) {
            <div class="flex flex-row items-center mb-24 mt-16 w-100-percent justify-between">
              <div class="flex flex-row items-center">
                <div class="mat-body-1 fw-700 title m-0 mr-12 fs-20">
                  <span class="mr-8 mat-headline-6 fw-700 fs-20">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
                </div>
                <div class="flex flex-row items-center">
                  <app-search-filter placeholder="SEARCH.SEARCH" (changed)="searchRvt($event)" class="search-section"></app-search-filter>
                  <button [matMenuTriggerFor]="menu1" #filterTrigger class="flex justify-between items-center fw-500 white-bg ml-12 filter">
                    <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
                    <span>{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
                  </button>
                  <mat-menu #menu1="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
                    <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
                    <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
                    <div class="flex flex-col overflow-class pr-10 filter-menu">
                      <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                        (click)="rvtFilterOptionChange(option)" >
                        <mat-icon *ngIf="selectedRvtFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                        <mat-icon *ngIf="selectedRvtFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                          </mat-icon>
                        <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                          {{option.label}}
                        </span>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </div>
              <app-environment-paginator [length]="rvtTableData?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)" class="ml-12 env-paginator"></app-environment-paginator>
            </div>
            <div class="pt-12 mb-12">
              <app-environment-table class="runbook-table" [displayColumns]="displayViewResultsColumns" [initialDataSource]="rvtTableData"
                [dataSourceLength]="true" [dataLoading]="!rvtResultsLoaded" [showSkeletonLoader]="true" pageName="rvtResults"
                (rowClicked)="onRvtRowClick($event)" [searchTerm]="rvtSearchTerm" (searchedResults)="searchedItems($event)"
                (configNameClick)="configurationNameClick($event, true)"
                [initialCreate]="allRvtStates?.length === 0 && !rvtResultsLoaded" (sorted)="resetPaginator()">
              </app-environment-table>
            </div>
          }
      </ng-container>
    </div>
  } @else {
    <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-150 fs-16">
      <img src="/assets/images/feature_not_available.png">
      <div class="mt-10 feature-not-avaliable">
        {{data?.deploymentClass === DeploymentClass.A ? ('FEATURE.PROD_FEATURE_NOT_AVAILABLE' | transloco) : ('FEATURE.FEATURE_NOT_AVAILABLE' | transloco)}}
      </div>
    </div>
  }
